import { useTranslation } from "react-i18next";
import {
  KeywordFeedbackCategory,
  KeywordFeedbackSubCategory,
} from "reedy-data/api";
import { Button } from "components/button";
import {
  getSubCategoryLabel,
  SUB_CATEGORIES,
  SUB_CATEGORY_TESTID,
} from "./KeywordFeedbackPopover.labels";
import { KeywordFeedbackPill } from "./KeywordFeedbackPill";

interface KeywordFeedbackSubReasonPickerProps {
  category: KeywordFeedbackCategory;
  onSelect: (subCategory: KeywordFeedbackSubCategory) => Promise<void>;
  onOther: () => void;
  onBack: () => void;
}

export const KeywordFeedbackSubReasonPicker = ({
  category,
  onSelect,
  onOther,
  onBack,
}: KeywordFeedbackSubReasonPickerProps) => {
  const { t } = useTranslation(["components"]);

  return (
    <div className="px-4 py-3 flex flex-col gap-2">
      <div className="flex flex-wrap gap-1.5">
        {SUB_CATEGORIES[category].map((subCategory) => (
          <KeywordFeedbackPill
            key={subCategory}
            onClick={() => onSelect(subCategory)}
            data-testid={`feedback-sub-${SUB_CATEGORY_TESTID[subCategory]}`}
          >
            {getSubCategoryLabel(t, subCategory)}
          </KeywordFeedbackPill>
        ))}
        <KeywordFeedbackPill onClick={onOther} data-testid="feedback-sub-other">
          {t("components:keywordsTab.keywordFeedbackPopover.categories.other")}
        </KeywordFeedbackPill>
      </div>
      <Button
        variant="link"
        size="small"
        type="button"
        onClick={onBack}
        className="self-start h-auto p-0 text-xs font-normal text-secondary-400 hover:text-secondary-600 hover:no-underline"
        data-testid="feedback-back"
      >
        {t("components:keywordsTab.keywordFeedbackPopover.back")}
      </Button>
    </div>
  );
};
